import { t } from "i18next";
import { dayjs } from "neetocommons/utils";

export const defaultTimePeriodOptions = () => {
  const today = dayjs().startOf("day");
  const startOfLastWeek = today.subtract(7, "day").startOf("week");

  const endOfLastWeek = today.subtract(7, "day").endOf("week");
  const lastMonthStart = today.subtract(1, "month").startOf("month");
  const lastMonthEnd = today.subtract(1, "month").endOf("month");
  const thisQuarterStart = dayjs().startOf("quarter");
  const thisQuarterEnd = dayjs().endOf("quarter");
  const lastQuarterStart = dayjs().subtract(1, "quarter").startOf("quarter");
  const lastQuarterEnd = dayjs().subtract(1, "quarter").endOf("quarter");
  const startOfLastYear = dayjs().subtract(1, "year").startOf("year");
  const endOfLastYear = dayjs().subtract(1, "year").endOf("year");
  const startOfYear = dayjs().startOf("year");
  const endOfYear = dayjs().endOf("year");

  const startOf24Hours = dayjs().subtract(24, "hour");
  const now = dayjs();
  const startOfLast7Days = dayjs().subtract(7, "day");
  const startOfWeek = dayjs().startOf("week");
  const startOfLast30Days = dayjs().subtract(30, "day");
  const startOfMonth = today.startOf("month");

  return [
    {
      label: t("neetoMolecules.dateRangeFilter.timePeriodOptions.allTime"),
      value: { startDate: null, endDate: null, rangeType: "all" },
    },
    {
      label: t("neetoMolecules.dateRangeFilter.timePeriodOptions.last24Hours"),
      value: { startDate: startOf24Hours, endDate: now, rangeType: "hours" },
    },
    {
      label: t("neetoMolecules.dateRangeFilter.timePeriodOptions.last7Days"),
      value: {
        startDate: startOfLast7Days,
        endDate: now,
        rangeType: "days",
      },
    },
    {
      label: t("neetoMolecules.dateRangeFilter.timePeriodOptions.thisWeek"),
      value: { startDate: startOfWeek, endDate: now, rangeType: "week" },
    },
    {
      label: t("neetoMolecules.dateRangeFilter.timePeriodOptions.lastWeek"),
      value: {
        startDate: startOfLastWeek,
        endDate: endOfLastWeek,
        rangeType: "week",
      },
    },
    {
      label: t("neetoMolecules.dateRangeFilter.timePeriodOptions.last30Days"),
      value: {
        startDate: startOfLast30Days,
        endDate: now,
        rangeType: "days",
      },
    },
    {
      label: t("neetoMolecules.dateRangeFilter.timePeriodOptions.thisMonth"),
      value: { startDate: startOfMonth, endDate: now, rangeType: "month" },
    },
    {
      label: t("neetoMolecules.dateRangeFilter.timePeriodOptions.lastMonth"),
      value: {
        startDate: lastMonthStart,
        endDate: lastMonthEnd,
        rangeType: "month",
      },
    },
    {
      label: t("neetoMolecules.dateRangeFilter.timePeriodOptions.thisQuarter"),
      value: {
        startDate: thisQuarterStart,
        endDate: thisQuarterEnd,
        rangeType: "quarter",
      },
    },
    {
      label: t("neetoMolecules.dateRangeFilter.timePeriodOptions.lastQuarter"),
      value: {
        startDate: lastQuarterStart,
        endDate: lastQuarterEnd,
        rangeType: "quarter",
      },
    },
    {
      label: t("neetoMolecules.dateRangeFilter.timePeriodOptions.thisYear"),
      value: { startDate: startOfYear, endDate: endOfYear, rangeType: "year" },
    },
    {
      label: t("neetoMolecules.dateRangeFilter.timePeriodOptions.lastYear"),
      value: {
        startDate: startOfLastYear,
        endDate: endOfLastYear,
        rangeType: "year",
      },
    },
    {
      label: t(
        "neetoMolecules.dateRangeFilter.timePeriodOptions.customDuration"
      ),
      value: "custom",
    },
  ];
};
